import { createSlice } from "@reduxjs/toolkit";

const authSLice = createSlice({
    name:"auth",
    initialState:{
        user: localStorage.getItem("userInfo") ? 
        JSON.parse(localStorage.getItem("userInfo")) :
        null,
        registerMessage: null,
        isEmailVerified: false
    }, 

    reducers:{
        login(state,action){
            state.user = action.payload;
        },
        logout(state) {
            state.user = null;
        },
        register(state, action){
            state.registerMessage = action.payload;

        },
        clearRegisterMessage(state) {
            state.registerMessage = null;
          },
        setEmail(state,action){
            state.user.email = action.payload;
          },

          setIsEmailVerified(state){
            state.isEmailVerified = true;
            state.registerMessage = null;
          }


    }
});


const authReducer = authSLice.reducer;
const authActions = authSLice.actions;

export {authActions , authReducer}